import { render, staticRenderFns } from "./TabConfirmed.vue?vue&type=template&id=64ab2272"
import script from "./TabConfirmed.vue?vue&type=script&lang=js"
export * from "./TabConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports